export function listScenarios(state) {
  return state.scenarios;
}